import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as appDataActions from '../../../../actions/appDataActions';
import Resources from '../../resourceLinks/ResourceLinks';
import Image from '../../image/SecondaryImage';
import LibraryImage from '../../image/SecondaryLibraryImage';
import AudioControls from "../../audio/SimpleAudioController";
import OptionFeedback from "../OptionFeedback";
import ScoreKpi from '../../kpi/ScoreKpi';//eslint-disable-line import/no-named-as-default
import * as trackingDataActions from "../../../../actions/trackingDataActions";
import * as userDataActions from "../../../../actions/userDataActions";
import * as appHelper from "../../../../helpers/appHelper";
import * as dataHelper from "../../../../helpers/dataHelper";
import * as appConstants from "../../../../constants/appConstants";
import * as objectConstants from "../../../../constants/objectConstants";
import * as kpiConstants from "../../../../constants/kpiConstants";
import * as assetConstants from '../../../../constants/assetConstants';
import * as keyboardConstants from '../../../../constants/keyboardConstants';
import * as imageHelper from '../../../../helpers/imageHelper';
import * as componentConstants from '../../../../constants/componentConstants';
import * as animationHelper from "../../../../helpers/animationHelper";

class SingleAnswerFeedback extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            option: this.props.option,
            options: this.props.options,
            locale: appHelper.getLocalData(this.props.option),
            hideFeedback: this.props.hideFeedback,
            showKpis: this.props.screenObject.scoring_type === objectConstants.SCORING_TYPE_ASSESSED && appHelper.isDefined(this.props.option.kpis) && this.props.option.kpis !== null,
            showProgression: false,
            enableProgression: this.props.screenObject.scoring_type !== objectConstants.SCORING_TYPE_ASSESSED || this.props.option.kpis === null,
            optionFeedback: [],
            kpiDashboardParams: {
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false
            },
            hasDialogs: appHelper.isDefined(this.props.option.dialogs) && this.props.option.dialogs.length > 0,
            dialogComplete: !appHelper.isDefined(this.props.option.dialogs) || this.props.option.dialogs.length === 0,
            hasBadges: appHelper.isDefined(this.props.option.badges) && this.props.option.badges.length > 0,
            badgesCollected: false,
            resourceLinks: [],
            hasResources: false,
            resourcesAreComplete: true,
            optionAsset: {
                src: ""
            },
            assetData: {},
            completionCalled: false,
            feedbackInterval: {},
            review_other_options_label: appHelper.getLocaleString("review_other_options_label"),
            hasLeftAsset: appHelper.isDefined(this.props.option.feedback_settings.left),
            hasRightAsset: appHelper.isDefined(this.props.option.feedback_settings.right),
            hasTopAsset: appHelper.isDefined(this.props.option.feedback_settings.top),
            hasBottomAsset: appHelper.isDefined(this.props.option.feedback_settings.bottom),
            imageStyles: {},
            imageClass: "",
            updateImageStyles: false,
            imageStylesSet: false,
            feedbackAsset: {
                src: ""
            },
            feedbackAssetData: {},
            creditLabel: `${appHelper.getLocaleString("credit_label")}`,
            refValue: `${this.props.option.option_id}_feedbackWrapper`,
            audio: {
                src: "",
            },
            showLabels: true,
            showAnimation: false,
        };
        this.show = this.show.bind(this);
        this.onFeedbackRevealed = this.onFeedbackRevealed.bind(this);
        this.onFeedbackHidden = this.onFeedbackHidden.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.handleOptionFeedback = this.handleOptionFeedback.bind(this);
        this.storeUserResponse = this.storeUserResponse.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.getLinkClass = this.getLinkClass.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.dialogsOnComplete = this.dialogsOnComplete.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getAssetType = this.getAssetType.bind(this);
        this.getInheritedFeedback = this.getInheritedFeedback.bind(this);
        this.checkIsReadyToComplete = this.checkIsReadyToComplete.bind(this);
        this.setComplete = this.setComplete.bind(this);
        this.showProgressButton = this.showProgressButton.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.onReview = this.onReview.bind(this);
        this.setFeedbackInterval = this.setFeedbackInterval.bind(this);
        this.checkShowProgressButton = this.checkShowProgressButton.bind(this);
        //new
        this.getImagePath = this.getImagePath.bind(this);
        this.setClass = this.setClass.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.getImageStyles = this.getImageStyles.bind(this);
        this.showTopOrLeftAssetColumn = this.showTopOrLeftAssetColumn.bind(this);
        this.showBottomOrRightAssetColumn = this.showBottomOrRightAssetColumn.bind(this);

        this.feedbackPanel =  React.createRef();
        this.contentWrapper =  React.createRef();
    }

    componentDidMount() {
        this.getAssets();
        //this.handleOptionFeedback();
        this.setResources();
        this.getImageStyles();
        this.show();
        this.setFeedbackInterval();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.option.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.option.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.hideFeedback !== nextProps.hideFeedback) {
            this.setState({hideFeedback: nextProps.hideFeedback});
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option),
                review_other_options_label: appHelper.getLocaleString("review_other_options_label"),
                creditLabel: `${appHelper.getLocaleString("credit_label")}`
            });
        }
    }

    componentDidUpdate() {
        if (this.checkIsReadyToComplete()) {
            this.setComplete();
        }
        if (this.state.hideFeedback) {
            this.hide();
        }

        if (!this.state.imageStylesSet) {
            this.getImageStyles();
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.feedbackInterval);
    }

    setFeedbackInterval() {
        let interval = setInterval(this.checkShowProgressButton, 500);
        this.setState({feedbackInterval: interval});
    }

    checkShowProgressButton() {
        if (this.showProgressButton()) {
            this.props.onEnableProgression(this.state.locale.progression_label);
            clearInterval(this.state.feedbackInterval);
        }
    }

    getAssets() {
        let screenAsset = {};
        let assetData = {};
        let feedbackAsset = {};
        let feedbackAssetData = {};

        if (appHelper.isDefined(this.state.option.image)) {
            screenAsset = this.getAssetType(this.state.option.image);
            assetData = Object.assign({}, this.state.option.image);
        }

        if (this.state.hasLeftAsset) {
            feedbackAsset = this.getAssetType(this.state.option.feedback_settings.left);
            feedbackAssetData = Object.assign({}, this.state.option.feedback_settings.left);
        } else if (this.state.hasRightAsset) {
            feedbackAsset = this.getAssetType(this.state.option.feedback_settings.right);
            feedbackAssetData = Object.assign({}, this.state.option.feedback_settings.right);
        } else if (this.state.hasTopAsset) {
            feedbackAsset = this.getAssetType(this.state.option.feedback_settings.top);
            feedbackAssetData = Object.assign({}, this.state.option.feedback_settings.top);
        } else if (this.state.hasBottomAsset) {
            feedbackAsset = this.getAssetType(this.state.option.feedback_settings.bottom);
            feedbackAssetData = Object.assign({}, this.state.option.feedback_settings.bottom);
        }


        if (feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            feedbackAssetData = Object.assign({}, feedbackAssetData, {
                allow_diagram_zoom: this.state.option.feedback_settings.allow_diagram_zoom,
                show_diagram_title: this.state.option.feedback_settings.show_diagram_title,
                show_diagram_description: this.state.option.feedback_settings.show_diagram_description,

            });
        }

        this.setState({
            screenAsset: Object.assign({}, screenAsset),
            assetData: Object.assign({}, assetData),
            feedbackAsset: Object.assign({}, feedbackAsset),
            feedbackAssetData: Object.assign({}, feedbackAssetData),
            enableProgression: !appHelper.isDefined(this.state.feedbackAssetData.constant) || this.state.feedbackAssetData.constant !== assetConstants.ASSET_TYPE_METRIC_RESULT ? true : this.state.enableProgression
        });

        if (appHelper.isDefined(this.state.option.audio) && appHelper.isDefined(this.state.locale.audio)) {
            let audio = appHelper.getAudioAsset(this.state.locale.audio);
            if (appHelper.isDefined(this.state.option.audio.enabled) && this.state.option.audio.enabled) {
                if (this.props.screenObject.asset_type_code === componentConstants.AUDIO_CHOICE || (appHelper.isDefined(this.state.option.audio.show_audio_controls) && this.state.option.audio.show_audio_controls)) {
                    this.setState({
                        audio: Object.assign({}, audio),
                    });
                } else {
                    let audioObj = {
                        audioRef: `audio_${audio.id}_${audio.type}`,
                    };
                    if (appHelper.isDefined(this.state.option.audio.auto_play) && this.state.option.audio.auto_play) {
                        this.props.actions.setAudio(audioObj);
                    }
                }
            }
            //}
        }
    }

    getAssetType(asset) {
        let returnAsset = {};
        if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
            returnAsset = appHelper.getIconAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
            returnAsset = appHelper.getImageAsset(asset);

        } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
            returnAsset = appHelper.getLibraryImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
            let characterAsset = appHelper.getCharacterAsset(asset);
            returnAsset = appHelper.getCharacterPose(characterAsset, asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
            returnAsset = Object.assign({}, asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
            returnAsset = Object.assign({}, returnAsset, {
                type: asset.constant
            });
        }

        return returnAsset;
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    storeUserResponse() {
        let selectedOptions = [this.state.option.option_id];
        let responseObj = {
            asset_id: this.props.asset_id,
            selectedOptions: selectedOptions,
            kpis: this.state.option.kpis !== null ? this.state.option.kpis : [],
            indicators: appHelper.isDefined(this.state.option.indicators) && this.state.option.indicators !== null ? this.state.option.indicators : [],
        };
        this.props.callbacks.storeUserResponse(responseObj);
    }


    scrollToTop() {
        let feedback = document.getElementById(`feedback_wrapper_${this.props.asset_id}`);
        this.props.callbacks.scrollToFeedback(feedback.offsetTop);
    }

    enableProgression() {
        this.setState({enableProgression: true});
    }

    getLinkClass() {
        return this.state.enableProgression ? "" : "disabled-link";
    }

    getDisabledState() {
        return !this.state.enableProgression;
    }

    handleOptionFeedback() {
        let feedbackOptions = [];
        let noMsgObj = {
            id: "none",
            feedback: "",
            options: [],
            checked: false,
        };

        let optionsForFeedback = [];
        for (let i = 0; i < this.props.options.length; i++) {
            let option = this.props.options[i];
            let locale = appHelper.getLocalData(option);

            let isChecked = this.state.option.option_id === option.option_id;
            let optionObject = {
                result: option.result,
                className: isChecked ? 'checked' : 'unchecked',
                option_text: locale.option,
                option_id: option.option_id,
                kpis: appHelper.isDefined(option.kpis) && option.kpis !== null ? option.kpis : []
            };

            if (isChecked) {
                optionsForFeedback = dataHelper.immutablePush(optionsForFeedback, optionObject);
            }

        }

        if (optionsForFeedback.length > 1) {

            optionsForFeedback.sort(function (a, b) {
                if (a.className < b.className) return -1;
                if (a.className > b.className) return 1;
                return 0;
            });
        }

        if (optionsForFeedback.length > 0) {
            noMsgObj = Object.assign({}, noMsgObj,
                {
                    options: Object.assign([], optionsForFeedback)
                }
            );
        }

        if (noMsgObj.options.length > 0) {
            feedbackOptions = dataHelper.immutablePush(feedbackOptions, noMsgObj);
        }


        this.setState({optionFeedback: Object.assign([], feedbackOptions)});
    }

    onFeedbackRevealed() {
        this.storeUserResponse();
        this.scrollToTop();
    }

    onFeedbackHidden() {
        //  this.props.callbacks.resizeWatcher();
        if (typeof this.props.onComplete !== 'undefined') {
            this.props.onComplete();
        }
    }

    showFeedbackContent() {
        this.setState({showFeedbackContent: true});
    }

    onProgressionClicked() {
        this.hide();
    }

    show() {
        let feedbackPanel = this.feedbackPanel.current;
        let params = {
            ele: feedbackPanel,
            duration: objectConstants.FEEDBACK_DURATION,
            delay: 0,
            callback: this.onFeedbackRevealed
        };
        animationHelper.showHeight(params);
    }

    hide() {
        this.setState({hideFeedback: false});
        let feedbackPanel = this.feedbackPanel.current;//this.refs[`${this.state.option.option_id}_feedbackPanel`];
        let params = {
            ele: feedbackPanel,
            duration: objectConstants.FEEDBACK_DURATION,
            delay: 0,
            callback: this.onFeedbackHidden
        };
        animationHelper.hideHeight(params);
    }


    onToolboxComplete(progression, asset_id, latestResponse) {
        this.setState({toolboxIsComplete: true});
    }

    setToolboxCallbacks() {
        this.setState(
            {
                toolboxCallbacks: Object.assign({}, this.state.toolboxCallbacks,
                    {
                        onObjectComplete: this.onToolboxComplete,
                        isReviewMode: function () {
                            return false;
                        }
                    }
                )
            }
        );
    }

    onBadgeCollected() {
        this.setState({badgesCollected: true});
        //this.hide();
    }

    dialogsOnComplete() {
        this.setState({dialogComplete: true});
    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.option);

        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0
        });

    }

    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    getInheritedFeedback(feedback_id) {
        let option = appHelper.getArrayObjectByKey(this.state.options, "option_id", feedback_id);
        let optionLocale = appHelper.getLocalData(option);
        return optionLocale.feedback;
    }

    checkIsReadyToComplete() {
        return !this.props.callbacks.hasNextObject(this.props.index)
            && this.state.option.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN
            && this.state.enableProgression
            && !this.state.completionCalled
            //&& ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete;
    }

    setComplete() {
        this.setState({completionCalled: true});
        this.props.onComplete();
    }

    showProgressButton() {
        /*return (
            (!this.props.callbacks.hasNextObject(this.props.screenObject) && this.state.option.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || this.props.callbacks.hasNextObject(this.props.screenObject))
            && appHelper.isDefined(this.state.locale.progression_label)
            && ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete;*/
        return this.state.enableProgression
            && appHelper.isDefined(this.state.locale.progression_label)
            //&& ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete;
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (this.state.enableProgression) {
                this.onReview();
            }
        }
    }

    onReview() {
        if (this.state.enableProgression) {
            this.props.onShowReview(`review_link_${this.state.option.option_id}`);
        }
    }

    setClass() {

        let className = "";
        if (appHelper.isDefined(this.state.option.feedback_settings.class_name) && this.state.option.feedback_settings.class_name.length > 0) {
            className += ` ${this.state.option.feedback_settings.class_name}`;
        } else {
            className += "standard-block";
        }

        if (appHelper.isDefined(this.state.option.feedback_settings.bullet_list_style) && this.state.option.feedback_settings.bullet_list_style !== null) {
            className += ` ${this.state.option.feedback_settings.bullet_list_style}`;
        }
        return className;
    }

    setIconClass() {
        let iconClass = '';

        if (this.state.hasLeftAsset) {

            iconClass += 'left-asset ';
        } else if (this.state.hasRightAsset) {
            iconClass += 'right-asset ';
        } else if (this.state.hasTopAsset) {
            iconClass += 'top-asset ';
        } else if (this.state.hasBottomAsset) {
            iconClass += 'bottom-asset ';
        }

        /*if (this.state.screenAsset.type === assetConstants.ASSET_TYPE_ICON) {
            iconClass += 'icon ';
        } else {
            iconClass += 'image ';
        }*/

        if (this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            iconClass += 'image ';
        }
        return iconClass;
    }

    getImageStyles() {
        let refValue = this.contentWrapper.current;
        if (appHelper.isDefined(refValue) && refValue !== null && appHelper.isDefined(this.state.feedbackAsset.src) && this.state.feedbackAsset.src.length > 0) {
            let assetStyles = imageHelper.checkAssetImageWidth(this.state.option.feedback_settings, this.state.feedbackAsset, refValue.offsetWidth).styles;
            this.setState({
                updateImageStyles: false,
                imageStylesSet: true,
                imageStyles: Object.assign({}, assetStyles),
                imageClass: imageHelper.getAssetImageClass(this.state.option.feedback_settings),
            });
        }
    }

    showTopOrLeftAssetColumn() {
        let showColumn = false;
        if (this.state.hasLeftAsset) {
            showColumn = true;
            if (this.state.option.result === objectConstants.SCORING_TYPE_REFLECTIVE && this.state.option.feedback_settings.left.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
                showColumn = false;
            }
        } else if (this.state.hasTopAsset) {
            showColumn = true;
            if (this.state.option.result === objectConstants.SCORING_TYPE_REFLECTIVE && this.state.option.feedback_settings.top.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
                showColumn = false;
            }
        }

        return showColumn;
    }


    showBottomOrRightAssetColumn() {
        let showColumn = false;
        if (this.state.hasRightAsset) {
            showColumn = true;
            if (this.state.option.result === objectConstants.SCORING_TYPE_REFLECTIVE && this.state.option.feedback_settings.right.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
                showColumn = false;
            }
        } else if (this.state.hasBottomAsset) {
            showColumn = true;
            if (this.state.option.result === objectConstants.SCORING_TYPE_REFLECTIVE && this.state.option.feedback_settings.bottom.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
                showColumn = false;
            }
        }

        return showColumn;
    }

    render() {
        return (

            <div className="a-c" ref={this.feedbackPanel}>
                <div className={`feedback-panel ${this.state.option.result}`}
                     id={`${this.state.option.option_id}_feedbackPanel`}>

                    <div className="feedback-content-col">

                        <div className={`paragraph-content-wrapper ${this.setIconClass()}`} ref={this.contentWrapper}>
                            {this.showTopOrLeftAssetColumn()
                                ?
                                <div className="asset-column">
                                    {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                    &&
                                    <Image screenObject={this.state.feedbackAssetData}
                                           imageClass={this.state.imageClass}
                                           imageStyles={this.state.imageStyles}/>

                                    }
                                    {this.state.feedbackAssetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                    &&
                                    <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                         style={this.state.imageStyles}>
                                        <img src={this.getImagePath(this.state.feedbackAsset.src)} alt=""/>
                                    </div>
                                    }

                                    {appHelper.isDefined(this.state.feedbackAsset.credit) && this.state.feedbackAsset.credit.length > 0 &&
                                    <div className={`image-credit`}
                                         style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.feedbackAsset.credit}</div>
                                    }

                                    {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_METRIC_RESULT && this.state.showKpis
                                        ? <ScoreKpi bite_id={this.props.responseData.bite_id}
                                                    displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}
                                                    showImmediateImpact={this.state.kpiDashboardParams.showImmediateImpact}
                                                    showTitle={this.state.kpiDashboardParams.showTitle}
                                                    onUpdateComplete={this.enableProgression}/>
                                        : null
                                    }


                                </div>
                                :
                                null
                            }
                            <div className="content-column">
                                {this.state.optionFeedback.length > 0 && this.props.option.enable_feedback
                                    ? <OptionFeedback feedback_options={this.state.optionFeedback}
                                                      asset_id={this.props.asset_id}
                                                      responseData={this.props.responseData}
                                    />
                                    : null
                                }

                                {appHelper.isDefined(this.state.locale.feedback) && this.state.locale.feedback.length > 0 && this.state.locale.feedback !== "<p><br></p>" && this.props.option.enable_feedback
                                    ? <div dangerouslySetInnerHTML={{__html: this.state.locale.feedback}}/>
                                    :
                                    appHelper.isDefined(this.state.option.feedback_id)
                                        ?
                                        <div
                                            dangerouslySetInnerHTML={{__html: this.getInheritedFeedback(this.state.option.feedback_id)}}/>
                                        :
                                        null
                                }

                                {
                                    appHelper.isDefined(this.state.option.audio) && (this.props.screenObject.asset_type_code === componentConstants.AUDIO_CHOICE || (appHelper.isDefined(this.state.option.audio.show_audio_controls) && this.state.option.audio.show_audio_controls)) && appHelper.isDefined(this.state.audio.id)
                                        ?
                                        <AudioControls audio={this.state.audio}
                                                       autoPlay={this.state.option.audio.auto_play}
                                                       showLabels={this.state.showLabels}
                                                       showAnimation={this.state.showAnimation}
                                                       audioRef={`text_audio_${this.state.option.asset_id}_${this.state.audio.id}_${this.state.audio.constant}`}/>
                                        :
                                        null
                                }

                                {
                                    this.state.hasResources
                                        ?

                                        <Resources resources={this.state.resourceLinks}
                                                   onResourcesComplete={this.onResourcesComplete}/>

                                        :
                                        null
                                }


                            </div>
                            {this.showBottomOrRightAssetColumn()
                                ?
                                <div className="asset-column">
                                    {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                    &&
                                    <Image screenObject={this.state.feedbackAssetData}
                                           imageClass={this.state.imageClass}
                                           imageStyles={this.state.imageStyles}/>
                                    }
                                    {this.state.feedbackAssetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                    &&
                                    <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                         style={this.state.imageStyles}>
                                        <img src={this.getImagePath(this.state.feedbackAsset.src)} alt=""/>


                                    </div>
                                    }
                                    {appHelper.isDefined(this.state.feedbackAsset.credit) && this.state.feedbackAsset.credit.length > 0 &&
                                    <div className={`image-credit`}
                                         style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.feedbackAsset.credit}</div>
                                    }

                                    {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_METRIC_RESULT && this.state.showKpis
                                        ? <ScoreKpi bite_id={this.props.responseData.bite_id}
                                                    displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}
                                                    showImmediateImpact={this.state.kpiDashboardParams.showImmediateImpact}
                                                    showTitle={this.state.kpiDashboardParams.showTitle}
                                                    onUpdateComplete={this.enableProgression}/>
                                        : null
                                    }

                                </div>
                                :
                                null
                            }
                        </div>
                        {
                            appHelper.isDefined(this.state.assetData.constant) && (!appHelper.isDefined(this.props.showImages) || (appHelper.isDefined(this.props.showImages) && this.props.showImages))
                                ?

                                <div className="feedback-image">
                                    <div className="image-container">
                                        {this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE || this.state.assetData.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE
                                            ?
                                            this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE
                                                ?
                                                <Image screenObject={this.state.assetData}/>
                                                :
                                                <LibraryImage screenObject={this.state.assetData}/>
                                            :
                                            <img src={this.getImagePath(this.state.screenAsset.src)} alt=""/>
                                        }
                                    </div>
                                </div>
                                :
                                null
                        }

                        {this.props.option.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && this.state.resourcesAreComplete && this.state.option.feedback_settings.include_explore_feedback
                            ?
                            <div className={`guroo-active-link text-center ${this.getLinkClass()}`} role="link"
                                 tabIndex="0"
                                 id={`review_link_${this.state.option.option_id}`}
                                 onKeyDown={this.setKeyboardAccessibility}
                                 onClick={this.onReview}>{this.state.review_other_options_label}</div>
                            : null
                        }

                    </div>
                </div>
            </div>

        );
    }
}

SingleAnswerFeedback.propTypes = {
    screenObject: PropTypes.object,
    option: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    responseData: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    index: PropTypes.number,
    onComplete: PropTypes.func,
    onShowReview: PropTypes.func,
    scrollToFeedback: PropTypes.func,
    actions: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    showImages: PropTypes.bool,
    onEnableProgression: PropTypes.func,
    lang: PropTypes.string.isRequired,
    hideFeedback: PropTypes.bool,
};

SingleAnswerFeedback.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleAnswerFeedback);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/singleAnswer/SingleAnswerFeedback.js
 **/